import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'

/**
 * @typedef {Object} RouteParameters
 *
 * @property {string[]} [avoid] - array of waypoints of route
 * @property {boolean} [considerTraffic] - whether to consider the traffic data
 * @property {Id} [objectId] - id of the vehicle to calculate the route for
 * @property {string} [scheduleDay] - the weekday used to calculate the route
 * @property {string} [scheduleTime] - the time used to calculate the route
 * @property {string} [scheduleType] - the calculation type of the route
 * @property {string[]} [hazmatClass] - array of the hazmat classes to consider for the calculation of the route
 * @property {string} [travelMode] - travel mode, can be either car or truck
 * @property {number} [vehicleAxleWeight] - axle width of the vehicle
 * @property {number} [vehicleHeight] - height of the vehicle
 * @property {number} [vehicleLength] - length of the vehicle
 * @property {number} [vehicleMaxSpeed] - maximal speed of the vehicle
 * @property {number} [vehicleWeight] - wieght of the vehicle
 * @property {number} [vehicleWidth] - width of the vehicle
 */
export const routeParametersPropType = PropTypes.shape({
    avoid: PropTypes.arrayOf(PropTypes.oneOf(['MOTORWAYS', 'TOLLROADS', 'FERRIES', 'UNPAVEDROADS', 'CARPOOLS'])),
    considerTraffic: PropTypes.bool,
    hazmatClass: PropTypes.arrayOf(
        PropTypes.oneOf([
            'USHAZMATCLASS1',
            'USHAZMATCLASS2',
            'USHAZMATCLASS3',
            'USHAZMATCLASS4',
            'USHAZMATCLASS5',
            'USHAZMATCLASS6',
            'USHAZMATCLASS7',
            'USHAZMATCLASS8',
            'USHAZMATCLASS9',
            'OTHERHAZMATEXPLOSIVE',
            'OTHERHAZMATHARMFULTOWATER',
            'OTHERHAZMATGENERAL'
        ])
    ),
    objectId: idPropType,
    scheduleDay: PropTypes.oneOf(['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']),
    scheduleTime: PropTypes.string,
    scheduleType: PropTypes.oneOf(['LEAVE_NOW', 'DEPART_AT', 'ARRIVE_AT']),
    travelMode: PropTypes.oneOf(['CAR', 'TRUCK']),
    vehicleAxleWeight: PropTypes.number,
    vehicleHeight: PropTypes.number,
    vehicleLength: PropTypes.number,
    vehicleMaxSpeed: PropTypes.number,
    vehicleWeight: PropTypes.number,
    vehicleWidth: PropTypes.number
})
